// extracted by mini-css-extract-plugin
export var completionBody = "_jj-2";
export var completionCard = "_jj-0";
export var completionFooter = "_jj-3";
export var completionTitle = "_jj-1";